import { FC, memo } from 'react';
import styles from './index.module.scss';
import { useRequest } from 'ahooks';
import dayjs from 'dayjs';
import { apiV2MicrogridOverviewAlarmLevelCountPost } from '@maxtropy/intelligent-dispath-apis-v2';
import { keepZeroOrLine } from '@/utils/utils';

interface ICenterBottomBox {
  className?: string;
}

const CenterBottomBox: FC<ICenterBottomBox> = ({ className }) => {
  const { data: alarmData } = useRequest(
    () =>
      apiV2MicrogridOverviewAlarmLevelCountPost({}).then(res => {
        return res;
      }),
    { pollingInterval: 1000 * 60 }
  );

  return (
    <div
      className={`${styles.bottomRow} ${className || ''}`}
      onClick={() =>
        window.open(
          window.IOTPLATFORMORIGIN +
            `/device/alarm/record?startTime=${dayjs().subtract(6, 'day').startOf('day').valueOf()}&endTime=${dayjs()
              .endOf('day')
              .valueOf()}`,
          '_blank'
        )
      }
    >
      <div className={styles.title}>近七日未恢复报警</div>
      <div className={styles.alarmBox}>
        <div className={styles.highest}>
          <div className={styles.num}>{keepZeroOrLine(alarmData?.topLevel)}</div>
          <div className={styles.text}>最高级</div>
        </div>
        <div className={styles.high}>
          <div className={styles.num}>{keepZeroOrLine(alarmData?.highLevel)}</div>
          <div className={styles.text}>高级</div>
        </div>
        <div className={styles.middle}>
          <div className={styles.num}>{keepZeroOrLine(alarmData?.middleLevel)}</div>
          <div className={styles.text}>中级</div>
        </div>
        <div className={styles.low}>
          <div className={styles.num}>{keepZeroOrLine(alarmData?.lowLevel)}</div>
          <div className={styles.text}>低级</div>
        </div>
        <div className={styles.lowest}>
          <div className={styles.num}>{keepZeroOrLine(alarmData?.lowestLevel)}</div>
          <div className={styles.text}>最低级</div>
        </div>
      </div>
    </div>
  );
};

export default CenterBottomBox;
